(function () {
  const storageKey = 'clikea.shipping.destination.v1';
  const roots = [...document.querySelectorAll('[data-cl-ship]')];
  if (!roots.length) return;

  function read() {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || 'null');
      return value && /^\d{5}$/.test(value.postalCode || '') ? value : null;
    } catch { return null; }
  }

  function display(value) {
    const place = value?.destination?.split(',')[0]?.trim() || value?.postalCode || 'México';
    const fullLabel = `Envío a ${place}`;
    const compactLabel = place.length > 12 ? place : fullLabel;
    roots.forEach((root) => {
      root.querySelector('[data-cl-ship-label]').textContent = compactLabel;
      root.querySelector('.cl-ship__trigger').title = fullLabel + '. Cambiar código postal';
      root.querySelector('input').value = value?.postalCode || '';
    });
  }

  function save(value) {
    try { localStorage.setItem(storageKey, JSON.stringify(value)); } catch { /* Browser storage may be unavailable. */ }
    display(value);
  }

  roots.forEach((root) => {
    const trigger = root.querySelector('.cl-ship__trigger');
    const panel = root.querySelector('.cl-ship__panel');
    const input = root.querySelector('input');
    const status = root.querySelector('[data-cl-ship-status]');
    const close = () => { panel.hidden = true; trigger.setAttribute('aria-expanded', 'false'); };

    trigger.addEventListener('click', () => {
      const opening = panel.hidden;
      roots.forEach((other) => {
        other.querySelector('.cl-ship__panel').hidden = true;
        other.querySelector('.cl-ship__trigger').setAttribute('aria-expanded', 'false');
      });
      panel.hidden = !opening;
      trigger.setAttribute('aria-expanded', String(opening));
      if (opening) {
        panel.style.transform = '';
        const box = panel.getBoundingClientRect();
        const offset = box.left < 14 ? 14 - box.left : box.right > window.innerWidth - 14 ? window.innerWidth - 14 - box.right : 0;
        panel.style.transform = 'translateX(' + offset + 'px)';
        input.focus();
      }
    });

    root.querySelector('[data-cl-ship-save]').addEventListener('click', () => {
      const postalCode = input.value.trim();
      if (!/^\d{5}$/.test(postalCode)) {
        status.textContent = 'Ingresa un código postal de cinco dígitos.';
        input.focus();
        return;
      }
      save({ postalCode });
      window.dispatchEvent(new Event('clikea:shipping-destination-saved'));
      status.textContent = 'Código postal guardado.';
      close();
      const quoteRoot = document.querySelector('.clpdp-quote[data-quote-endpoint]');
      if (quoteRoot) {
        const zip = quoteRoot.querySelector('.clpdp-quote__form input');
        const toggle = quoteRoot.querySelector('.clpdp-quote__toggle');
        zip.value = postalCode;
        if (quoteRoot.querySelector('.clpdp-quote__panel').hidden) toggle.click();
        quoteRoot.querySelector('.clpdp-quote__submit').click();
        quoteRoot.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      }
    });
    root.querySelector('[data-cl-ship-clear]').addEventListener('click', () => {
      try {
        localStorage.removeItem(storageKey);
        localStorage.removeItem('clikea.shipping.quotes.v1');
      } catch { /* Storage may be unavailable. */ }
      display(null);
      status.textContent = 'Código postal eliminado.';
      window.dispatchEvent(new Event('clikea:shipping-cleared'));
      close();
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') { event.preventDefault(); root.querySelector('[data-cl-ship-save]').click(); }
      if (event.key === 'Escape') close();
    });
    document.addEventListener('click', (event) => { if (!root.contains(event.target)) close(); });
  });

  window.addEventListener('clikea:shipping-quoted', (event) => {
    const quote = event.detail;
    if (quote && /^\d{5}$/.test(quote.postalCode || '')) save({ postalCode: quote.postalCode, destination: quote.destination });
  });
  window.addEventListener('storage', (event) => { if (event.key === storageKey) display(read()); });
  display(read());
})();
